import { TerminalViewTable } from './components/Table'
import React from 'react'
import { useEffect, useState } from 'react'
import { cancelToken, get } from '@fareye/utils'
import { Flex, styled } from '@fareye/ui'
import { terminalView } from '@fareye/configs'
import { Header } from './components/Header'
import { useMemo } from 'react'
import { publicTerminalViewConfig } from '../../config/constants'
import queryString from 'query-string'
import { IMapper } from '@fareye/common'

const TerminalViewContainer: any = styled(Flex)`
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  background: ${terminalView.darkTheme.bodyBgColor};
  overflow: hidden;
`
const TerminalViewUpperTableContainer: any = styled(Flex)`
  min-height: calc(50vh - 100px);
  @media (max-width: 1440px) {
    margin-bottom: 24px;
  }

  @media (min-width: 1441px) and (max-width: 3840px) {
    margin-bottom: 44px;
  }
  @media (min-width: 3841px) {
    margin-bottom: 90px;
  }
`
const TerminalViewTableContainer = styled.div`
  min-height: calc(100vh - 100px);
  box-sizing: border-box;
  @media (max-width: 1920px) {
    margin-left: 16px;
    margin-right: 16px;
  }
  @media (min-width: 1920px) and (max-width: 3840px) {
    margin-left: 40px;
    margin-right: 40px;
  }
  @media (min-width: 3840px) {
    margin-left: 120px;
    margin-right: 106px;
  }
`

export const PublicTerminalView = function(props: IMapper) {
  const params = queryString.parse(location.search)
  const config = publicTerminalViewConfig
  const view: any = params.view || 'arrival_departure'
  const slug = params.shareable_slug
  const [hub, setHub] = useState('')
  const [pageSize, setPageSize] = useState(
    ['departure', 'arrival'].includes(view) ? 10 : 4
  )
  const [fetchedDataArrival, setFetchedDataArrival] = useState([])
  const [fetchedDataDeparture, setFetchedDataDeparture] = useState([])
  const [dataLoading, setDataLoading] = useState(true)
  const [refreshData, setRefreshData] = useState(0)

  async function getTableData(
    slug: any,
    apiURL: any,
    setFetchedData: any,
    tableName: any
  ) {
    const sourceRnM = cancelToken().source()
    try {
      setDataLoading(true)
      const url = `${apiURL}?shareableSlug=${slug}`
      const resp = await get(url, sourceRnM.token)
      const { status, data } = resp
      if (status >= 200 && status < 300) {
        setFetchedData(data.data)
        setHub(data.hubName)
        setDataLoading(false)
      }
    } catch (e:any) {
      setDataLoading(false)
      console.error(
        `Could not Fetch Terminal View ${tableName} for hub ${hub}`,
        e
      )
    }
  }

  useEffect(() => {
    {
      ;['arrival', 'arrival_departure'].includes(view)
        ? getTableData(
            slug,
            config?.children?.arrival?.config?.apiConfig?.apiURL,
            setFetchedDataArrival,
            'arrival'
          )
        : null
    }
    {
      ;['departure', 'arrival_departure'].includes(view)
        ? getTableData(
            slug,
            config?.children?.departure?.config?.apiConfig?.apiURL,
            setFetchedDataDeparture,
            'departure'
          )
        : null
    }
  }, [refreshData])
  const arrivalTable = useMemo(() => {
    return (
      <TerminalViewTable
        pageSize={pageSize}
        tableName={'ARRIVALS'}
        fetchedDataFromApi={fetchedDataArrival}
        columns={config?.children?.arrival?.config?.columns ?? []}
        dataLoading={dataLoading}
        pageChangeTimeInterval={config?.page?.paginationTimeInterval}
      />
    )
  }, [hub, refreshData, fetchedDataArrival, dataLoading, config, pageSize])
  const departureTable = useMemo(() => {
    return (
      <TerminalViewTable
        pageSize={pageSize}
        tableName={'DEPARTURES'}
        columns={config?.children?.departure?.config?.columns ?? []}
        fetchedDataFromApi={fetchedDataDeparture}
        dataLoading={dataLoading}
        pageChangeTimeInterval={config?.page?.paginationTimeInterval}
      />
    )
  }, [hub, refreshData, fetchedDataDeparture, dataLoading, config, pageSize])
  return (
    <TerminalViewContainer column>
      <Header
        setPageSize={setPageSize}
        arrivalOrDeparture
        setRefreshData={setRefreshData}
        config={config}
        view={view}
        hub={hub}
      />
      <TerminalViewTableContainer>
        {['arrival', 'arrival_departure'].includes(view) ? (
          <TerminalViewUpperTableContainer>
            {arrivalTable}
          </TerminalViewUpperTableContainer>
        ) : null}
        {['departure', 'arrival_departure'].includes(view) ? (
          <TerminalViewUpperTableContainer>
            {departureTable}
          </TerminalViewUpperTableContainer>
        ) : null}
      </TerminalViewTableContainer>
    </TerminalViewContainer>
  )
}
